import classes from './PatientDetailsHeader.module.css'

import PatientDetailsControls from "./PatientDetailsControls";
import Card from '../../common/Card';
import Tag from '../../fragments/Tag';
import EditPatientData from './EditPatientData';
import { useSelector } from 'react-redux';
import DetailsAlerts from './DetailsAlerts';
import { formatDateLocal, patientHasCompleteAddress } from '../../../lib/script';
import { formatPatientName } from '../../../lib/patientName';
import GlobalTooltip from '../../common/GlobalTooltip';
import { useUserTabEditPermissionDisabled } from '../../../lib/usersPermissions';
import ReturningPatient from './ReturningPatient';
import BodySimpleModalV3 from '../../common/modal/BodySimpleModalV3';
import PatientOrChart from './PatientOrChart';

const PatientDetailsHeader = ({hasClear, detailsExtraControls, noEdit}) => {
    let userPermissionPatientView = useUserTabEditPermissionDisabled('patient_view')

    const activeCase = useSelector(state => state.case.activeCase)
    const dob = activeCase?.patient?.dob

    const dobTooltip = dob ? formatDateLocal(dob) : null

    return <Card>
        {activeCase && activeCase.patient && <div className={classes.details_header}>
            <div className={'flex-container'}>
                <PatientOrChart item={activeCase} />
                <div>
                    
                    <div className={classes.tags_container}>
                        
                        <div>
                            <BodySimpleModalV3
                                message={dobTooltip ? `DOB: ${dobTooltip}` : ''}
                                disabled={!dobTooltip}
                            >
                                <h1>
                                    {formatPatientName(activeCase.patient)}
                                </h1>
                            </BodySimpleModalV3>
                        </div>
                        {userPermissionPatientView && !noEdit && <EditPatientData data={activeCase}/>}
                        <div className={classes.tags_container}>
                            {activeCase?.patient?.is_minor ? <Tag>Minor</Tag> : ''}
                            {activeCase?.patient?.is_disabled ? <Tag>Disabled</Tag> : ''}
                            <ReturningPatient caseData={activeCase?.case} />
                        </div>
                    </div>
                    <div className={classes.address_container}>
                        <i className='ti ti-building-skyscraper'></i>
                        {activeCase.patient?.contact_information?.address_1 ? activeCase.patient.contact_information.address_1 + ', ' : ''} 
                        {activeCase.patient?.contact_information?.city ? activeCase.patient.contact_information.city + ', '  : ''} 
                        {activeCase.patient?.contact_information?.state ? activeCase.patient.contact_information.state + ', '  : ''} 
                        {activeCase.patient?.contact_information?.zip ? activeCase.patient.contact_information.zip : ''}

                        {!patientHasCompleteAddress(activeCase?.patient?.contact_information) && <>
                            <GlobalTooltip danger={true}>
                                <p>Patient Address is incomplete</p>
                            </GlobalTooltip>
                        </>}
                    </div>
                </div>
            </div>
            <PatientDetailsControls data={activeCase} hasClear={hasClear} detailsExtraControls={detailsExtraControls}/>
            <DetailsAlerts />
        </div>}
    </Card>
}

export default PatientDetailsHeader